/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { connectInstagramAccount } from '../fn/instagram-account-connection/connect-instagram-account';
import { ConnectInstagramAccount$Params } from '../fn/instagram-account-connection/connect-instagram-account';
import { disconnectInstagramAccount } from '../fn/instagram-account-connection/disconnect-instagram-account';
import { DisconnectInstagramAccount$Params } from '../fn/instagram-account-connection/disconnect-instagram-account';
import { getInstagramConnectionStatus } from '../fn/instagram-account-connection/get-instagram-connection-status';
import { GetInstagramConnectionStatus$Params } from '../fn/instagram-account-connection/get-instagram-connection-status';
import { InstagramConnectionResponse } from '../models/instagram-connection-response';
import { verifyInstagramAccount } from '../fn/instagram-account-connection/verify-instagram-account';
import { VerifyInstagramAccount$Params } from '../fn/instagram-account-connection/verify-instagram-account';

@Injectable({ providedIn: 'root' })
export class InstagramAccountConnectionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getInstagramConnectionStatus()` */
  static readonly GetInstagramConnectionStatusPath = '/v1/api/ui/instagram-accounts/status';

  /**
   * Get Instagram connection status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInstagramConnectionStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInstagramConnectionStatus$Response(params?: GetInstagramConnectionStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<InstagramConnectionResponse>> {
    return getInstagramConnectionStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Instagram connection status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInstagramConnectionStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInstagramConnectionStatus(params?: GetInstagramConnectionStatus$Params, context?: HttpContext): Observable<InstagramConnectionResponse> {
    return this.getInstagramConnectionStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<InstagramConnectionResponse>): InstagramConnectionResponse => r.body)
    );
  }

  /** Path part for operation `connectInstagramAccount()` */
  static readonly ConnectInstagramAccountPath = '/v1/api/ui/instagram-accounts/connect';

  /**
   * Connect the Instagram account selected in Meta.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectInstagramAccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connectInstagramAccount$Response(params: ConnectInstagramAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<InstagramConnectionResponse>> {
    return connectInstagramAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Connect the Instagram account selected in Meta.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectInstagramAccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connectInstagramAccount(params: ConnectInstagramAccount$Params, context?: HttpContext): Observable<InstagramConnectionResponse> {
    return this.connectInstagramAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<InstagramConnectionResponse>): InstagramConnectionResponse => r.body)
    );
  }

  /** Path part for operation `verifyInstagramAccount()` */
  static readonly VerifyInstagramAccountPath = '/v1/api/ui/instagram-accounts/verify';

  /**
   * Verify token and retry webhook subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyInstagramAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  verifyInstagramAccount$Response(params?: VerifyInstagramAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<InstagramConnectionResponse>> {
    return verifyInstagramAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Verify token and retry webhook subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifyInstagramAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  verifyInstagramAccount(params?: VerifyInstagramAccount$Params, context?: HttpContext): Observable<InstagramConnectionResponse> {
    return this.verifyInstagramAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<InstagramConnectionResponse>): InstagramConnectionResponse => r.body)
    );
  }

  /** Path part for operation `disconnectInstagramAccount()` */
  static readonly DisconnectInstagramAccountPath = '/v1/api/ui/instagram-accounts';

  /**
   * Disconnect Instagram from the current company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disconnectInstagramAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  disconnectInstagramAccount$Response(params?: DisconnectInstagramAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return disconnectInstagramAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Disconnect Instagram from the current company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disconnectInstagramAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disconnectInstagramAccount(params?: DisconnectInstagramAccount$Params, context?: HttpContext): Observable<void> {
    return this.disconnectInstagramAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
